import { Component, OnInit, Input } from '@angular/core';
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { SetValid } from "src/classes/Common/SetValid";
import { CardColor, ServiceCardColor, IconService } from 'src/classes/Customers/CardColor';
import { Menu } from "primeng/menu";
import { PopupItem } from "src/classes/Common/PopupItem";
import {  MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { screenId } from "src/environments/environment";
import { DynamiceditScreenComponent } from "src/app/Customers/dynamicedit-screen/dynamicedit-screen.component";
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { CommonFunctions } from "src/app/helper/CommonFunctions";
import { ControlsService } from 'src/app/services/Common/controls.service';
import { CustCardTabService } from 'src/app/services/Custcard/cust-card-tab/cust-card-tab.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-custcardview42',
    templateUrl: './custcardview42.component.html',
    styleUrls: ['./custcardview42.component.css'],
    providers: [HttpServiceCustomer, CommonFunctions, MessageService]
})
export class Custcardview42Component implements OnInit {
    customerin: CustomerIn = new CustomerIn();
    receivedvalid: SetValid = new SetValid();

    cardscolor: CardColor[];
    state: string = "loading";
    activeCardColor: CardColor;

    servicescardcolor: ServiceCardColor[];
    iconsservice: IconService[];

    items: ExtendedMenuItem[];
    attachmentItemsId: number = 3;
    attachmentItems: ExtendedMenuItem[];
    openedMenu: Menu;

    isDeletingCard: boolean = false;
    isCardMenuOpened: boolean = false;

    dynamicDialogRef: DynamicDialogRef;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    previousTab: number = 0;
    saveData: boolean = false;
    componentHasChanged: boolean = false;

    // isDisabledMenuItem = {
    //     18: 74,
    //     19: 75,
    //     20: 76,
    // }

    // isDisabledMenuItem: any[];

    @Input() customerId: number = 0;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private dynamicDialogService: DynamicDialogService,
        private custCardTabService: CustCardTabService,
        private commonFunctions: CommonFunctions,
        private messageService: MessageService,
        private controlsService: ControlsService,
        private logger: NGXLogger
    ) {
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.onTabChange(tabIndex));
    }

    ngOnInit() {
        this.customerin.customer_id = this.customerId;

        this.httpServiceCustomer.getCardsColor(this.customerin)
            .subscribe((data: CardColor[]) => {
                this.cardscolor = data;
                console.log("Count of cardcolors: " + this.cardscolor.length);

                if (this.cardscolor.length == 0) {
                    this.state = "nocardcolors";
                }
                else {
                    this.state = "loaded";
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get the list of items in popup
        this.httpServiceCustomer.getItemsMenuByScreen({ screen_id: screenId.Customers.custcardview })
            .subscribe((res: [PopupItem]) => {
                let m: ExtendedMenuItem[] = [];

                // this.isDisabledMenuItem = res.filter(item =>
                //     item.cb_id_disable != -1 && item.mn_menu_id == this.attachmentItemsId
                // ).map(item => ({
                //     mn_id: item.mn_id,
                //     cb_id_disable: item.cb_id_disable,
                // }));

                res.forEach((item) => {
                    const menuItem: ExtendedMenuItem = {
                        label: item.mn_menuitem_title,
                        icon: item.mn_icon.split(".svg")[0],
                        menu_Id: item.mn_menu_id,
                        // disabled: this.isDisabledMenuItem[item.mn_id] ? this.isDisabled(this.isDisabledMenuItem[item.mn_id]) : false,

                        // changed the "disabled" attribute to a specific value in res
                        disabled: item.cb_id_disable != -1 ? this.isDisabled(item.cb_id_disable) : false,
                        command: () => this.menuItemCommand(item.mn_order_id)
                    };
                    m.push(menuItem);
                });

                this.items = m;
                this.attachmentItems = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == this.attachmentItemsId);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get services list for cardcolor
        this.httpServiceCustomer.getServicesCardColor()
            .subscribe((res: ServiceCardColor[]) => {
                this.servicescardcolor = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get icons list for services
        this.httpServiceCustomer.getIconsServices()
            .subscribe((res: IconService[]) => {
                this.iconsservice = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngOnDestroy(): void {
        this.custCardTabService.tabIndex = 57;
        this.dynamicDialogService.closeDialog();
        this.saveCardsData();
    }

    onTabChange(tabIndex: number): void {
        if (tabIndex == 42) {
            this.saveData = false;
        }

        if (this.previousTab == 42) {
            this.dynamicDialogService.closeDialog();
            this.saveCardsData();
        }
        this.previousTab = tabIndex;
    }

    addNewCardColor(): void {
        const maxId: number = this.cardscolor.length ? this.cardscolor.reduce((accumulator, current) => {
            return accumulator.indMkz > current.indMkz ? accumulator : current;
        }).indMkz + 1 : 1;

        let cardColor: CardColor = {
            customerId: this.customerin.customer_id,
            regDate: this.commonFunctions.dateToString(new Date()),
            iconName: "",
            companies: "",
            oxyGen: "",
            comments: "",
            description: "",
            indMkz: -1,//maxId,
            serviceInd: 0,
            serviceName: "",
            serviceIconId: 0
        }

        this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
            data: {
                input_id: 9, value: { cardColor, services: this.servicescardcolor },
            },
            header: "כרטיס כימיה חדש",
            styleClass: "modal modal_purpose_chemistry-edit"
        });

        this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
            if (receivedObject && receivedObject.input_id === 9) {
                this.cardscolor.unshift(receivedObject.value);
                this.state = "loaded";
                this.cardscolor = this.cardscolor.filter((item: CardColor) => item.lastDeleted != true);
                this.showMessage("success", "כרטיס כימיה התווסף בהצלחה.");
            }
        });
    }

    // Function that closes all modals
    cancelButton() {
        this.isDeletingCard = false;
    }

    // Commands for menu items by their id
    menuItemCommand(order_id: number): void {
        console.log("order_id: " + order_id);

        switch (order_id) {
            case 1: {
                // editing
                this.isCardMenuOpened = false;
                this.editCardColor(this.activeCardColor);
                break;
            }
            case 2: {
                // copy card
                this.isCardMenuOpened = false;
                this.copyCardColor(this.activeCardColor);
                break;
            }
            case 3: {
                // deleting
                this.isCardMenuOpened = false;
                this.isDeletingCard = true;
                break;
            }
        }
        this.isCardMenuOpened = false;
    }

    // Function that opens chemistry card editing modal
    editCardColor(cardColor: CardColor): void {
        this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
            data: {
                input_id: 9, value: { cardColor, services: this.servicescardcolor },
            },
            header: "עריכת כימיה צבע",
            styleClass: "modal modal_purpose_chemistry-edit"
        });

        this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
            if (receivedObject && receivedObject.input_id === 9) {
                if (this.cardscolor[this.cardscolor.indexOf(cardColor)] != receivedObject.value) {
                    this.showMessage("success", "כרטיס כימיה עודכן בהצלחה.");
                }

                this.cardscolor[this.cardscolor.indexOf(cardColor)] = receivedObject.value;
            }
            this.sortCards();
        });
    }

    // Function that copies chemistry card
    copyCardColor(cardColor: CardColor): void {
        (document.activeElement as HTMLElement).blur();

        let newCardColor: CardColor = Object.assign({}, cardColor);
        newCardColor.indMkz1 = Math.floor(Math.random() * (999999 - 100000)) + 100000;
        newCardColor.indMkz = -1;
        newCardColor.regDate = this.commonFunctions.dateToString(new Date());

        this.cardscolor.unshift(newCardColor);

        this.showMessage("success", "כרטיס כימיה שוכפל בהצלה.");
    }

    // Function that deletes chemistry card
    deleteCardColor(cardColorToRemove: CardColor): void {
        if (this.cardscolor.length != 1) {
            this.cardscolor = this.cardscolor.filter((cardColor: CardColor) => {
                return cardColor != cardColorToRemove;
            });
        }
        else {
            this.cardscolor[0].lastDeleted = true;
        }

        if (this.cardscolor.length == 0 || this.cardscolor[0].lastDeleted) {
            this.state = "nocardcolors";
        }

        this.isDeletingCard = false;
        this.showMessage("success", "כרטיס כימיה נמחק בהצלחה.");
    }

    // Card menu toggle function
    toggleSubMenu(event: PointerEvent, menu: Menu, cardColor: CardColor, isMobile: boolean): void {
        if (isMobile) {
            this.activeCardColor = cardColor;
            
            this.isCardMenuOpened = true;
        } else {
            menu.toggle(event);
            this.activeCardColor = cardColor;

            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    // Function of saving chemistry editing
    editServices(): void {
        (document.activeElement as HTMLElement).blur();

        this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
            data: {
                input_id: 8, value: { services: this.servicescardcolor, icons: this.iconsservice },
            },
            header: "עריכת/הוספת סוגי כימיה",
            styleClass: "modal modal_purpose_chemistry-service-edit"
        });

        this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
            if (receivedObject && receivedObject.input_id === 8) {
                this.servicescardcolor = receivedObject.value;
                this.cardscolor.forEach((cardColor: CardColor) => {
                    cardColor.iconName = this.servicescardcolor.find((service: ServiceCardColor) => service.serviceInd == cardColor.serviceInd).serviceIconName;
                    cardColor.serviceName = this.servicescardcolor.find((service: ServiceCardColor) => service.serviceInd == cardColor.serviceInd).serviceName;
                });
            }
        });
    }

    // Function of sorting all cards by regDate
    sortCards(): void {
        this.cardscolor.sort((item1, item2) => {
            return (this.commonFunctions.stringToDate(item2.regDate).getTime() - this.commonFunctions.stringToDate(item1.regDate).getTime());
        });
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }

    // Function of saving changes
    saveCardsData(): void {
        if (this.componentHasChanged) {
            this.httpServiceCustomer.setCardsColor(this.cardscolor)
                .then((res: SetValid) => {
                    this.receivedvalid = res;
                    console.log("Cardcolor data saved: " + this.receivedvalid.answer);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }
}